import React from 'react';
import styled from 'styled-components';
import { basicColor, transition } from '@/styles/template';

interface AProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
	white?: boolean;
}

const A = styled.a<AProps>`
  cursor: pointer;
  color: ${basicColor.primary};
  transition: ${transition.fastEnd};
  border-bottom: 1px solid transparent;
  
  &:hover {
    opacity: .8;
    border-bottom-color: ${basicColor.primary};
  }
`;

export default A;